<template>
    <div class="settings">
        <h1>{{$t('editTitle', { name: rule.name })}}</h1>
        <b-form>
            <b-form-group>
                <b-form-input v-model="rule.name" required
                        :placeholder="$t('namePlaceholder')"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('allConditions')" label-cols="4" label-for="manual-all">
                <b-checkbox switch v-model="rule.allconditions" ref="all" id="manual-all"></b-checkbox>
            </b-form-group>
            <h3>{{$t('conditionsTitle')}}</h3>
            <b-container class="rows">
              <b-form-row>
                <b-col>{{$t('conditionsHeader.field')}}</b-col>
                <b-col>
                  <div style="display:inline-block" class="px-1">{{$t('conditionsHeader.insensitive')}}</div>
                  <div style="display:inline-block" class="px-2">{{$t('conditionsHeader.match')}}</div>
                </b-col>
                <b-col>{{$t('conditionsHeader.text')}}</b-col>
                <div class="delete"></div>
              </b-form-row>
                <b-form-row v-for="(c, ind) in rule.conditions" :key="ind">
                    <b-col><b-form-select v-model="c.field" :options="fields"></b-form-select></b-col>
                    <b-col>
                        <div style="display:inline-block">
                          <b-checkbox :checked="c.match.charAt(0) === '~'"
                          @input="setInsensitive(ind, $event)">
                        </b-checkbox></div>
                        <div style="display:inline-block">
                            <b-form-select :value="condMatch(ind)" :options="matches"
                            @input="setMatch(ind, $event)"></b-form-select>
                        </div>
                    </b-col>
                    <b-col><b-form-input v-model="c.data"></b-form-input></b-col>
                    <div class="delete" @click="doDeleteCondition(ind)">
                        <font-awesome-icon icon="times" size="lg"></font-awesome-icon>
                    </div>
                </b-form-row>
                <b-row v-if="!rule.conditions.length">
                    <b-col @click="doAddCondition">{{$t('noConditions')}}</b-col>
                </b-row>
            </b-container>
            <b-button @click="doAddCondition">{{$t('addCondition')}}</b-button>

            <h3>{{$t('actionsTitle')}}</h3>
            <b-container class="rows">
                <b-form-row v-for="(a, ind) in rule.actions" :key="ind">
                    <b-col><b-form-select v-model="a.action" :options="actions" @input="updateActionData(ind)">
                    </b-form-select></b-col>
                    <b-col>
                      <b-form-select v-if="['move', 'copy'].indexOf(a.action)!==-1"
                        :options="folders" v-model="a.folderData" @input="updateActionData(ind)"></b-form-select>
                      <b-form-input v-if="['forward', 'forwardfrom'].indexOf(a.action)!==-1"
                        v-model="a.addrData" :placeholder="$t('actions.addressPlaceholder')"
                          @input="updateActionData(ind)"></b-form-input>
                      <b-form-input v-if="['header'].indexOf(a.action)!==-1"
                          v-model="a.headerData" :placeholder="$t('actions.headerPlaceholder')"
                          @input="updateActionData(ind)"></b-form-input>
                      <b-form-input v-if="['keywords'].indexOf(a.action)!==-1"
                          v-model="a.keywordData" :placeholder="$t('actions.keywordPlaceholder')"
                          @input="updateActionData(ind)"></b-form-input>
                    </b-col>
                    <div class="delete" @click="doDeleteAction(ind)">
                        <font-awesome-icon icon="times" size="lg"></font-awesome-icon>
                    </div>
                </b-form-row>
                <b-row v-if="!rule.actions.length">
                    <b-col @click="doAddAction">{{$t('noActions')}}</b-col>
                </b-row>
            </b-container>
            <b-button @click="doAddAction">{{$t('addAction')}}</b-button><br/>

            <b-button variant="primary" :disabled="!isValid" @click="doSave">{{$t('save')}}</b-button>
            <b-button @click="$router.back()">{{$t('cancel')}}</b-button>

        </b-form>
      <!--{{rule}}
      <hr>
      {{$store.state.settings.msgrules}}-->

    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'automaticRuleEditor',
  components: { FontAwesomeIcon },
  i18nOptions: { keyPrefix: 'rules.automaticRules' },
  data: function() {
    return {
      rule: {
        name: '',
        allconditions: false,
        conditions: [],
        actions: [],
        id: -1
      },
      fields: [
        { value: 'subject', text: this.$t('condfields.subject') },
        { value: 'to', text: this.$t('condfields.to') },
        { value: 'cc', text: this.$t('condfields.cc') },
        { value: 'to,cc', text: this.$t('condfields.tocc') },
        { value: 'from', text: this.$t('condfields.from') },
        { value: 'fromaddr', text: this.$t('condfields.fromaddr') },
        { value: 'from,to,cc', text: this.$t('condfields.fromtocc') },
        { value: 'body', text: this.$t('condfields.body') },
        { value: 'size', text: this.$t('condfields.size') },
        { value: 'spamscore', text: this.$t('condfields.spamscore') },
        { value: 'quarantine', text: this.$t('condfields.quarantine') },
        { value: 'markedread', text: this.$t('condfields.markedread') },
        { value: 'keyword', text: this.$t('condfields.keyword') },
        { value: 'flag', text: this.$t('condfields.flag') },
        { value: 'rulematch', text: this.$t('condfields.rulematch') },
        { value: 'datenow', text: this.$t('condfields.datenow') },
        { value: 'timenow', text: this.$t('condfields.timenow') },
        { value: 'msgdate', text: this.$t('condfields.msgdate') }
      ],
      matches: [
        { value: 'eq', text: this.$t('condmatches.eq') },
        { value: 'ne', text: this.$t('condmatches.ne') },
        { value: 'lt', text: this.$t('condmatches.lt') },
        { value: 'le', text: this.$t('condmatches.le') },
        { value: 'gt', text: this.$t('condmatches.gt') },
        { value: 'ge', text: this.$t('condmatches.ge') },
        { value: 'ss', text: this.$t('condmatches.ss') },
        { value: '!ss', text: this.$t('condmatches.nss') },
        { value: 'wc', text: this.$t('condmatches.wc') },
        { value: '!wc', text: this.$t('condmatches.nwc') },
        { value: 're', text: this.$t('condmatches.re') },
        { value: '!re', text: this.$t('condmatches.nre') }
      ],
      actions: [
        { value: 'stop', text: this.$t('actions.stop') },
        { value: 'flag', text: this.$t('actions.flag') },
        { value: 'delete', text: this.$t('actions.delete') },
        { value: 'quarantine', text: this.$t('actions.quarantine') },
        { value: 'markread', text: this.$t('actions.markRead') },
        { value: 'keywords', text: this.$t('actions.keywords') },
        { value: 'copy', text: this.$t('actions.copy') },
        { value: 'move', text: this.$t('actions.move') },
        { value: 'forward', text: this.$t('actions.forward') },
        { value: 'forwardfrom', text: this.$t('actions.forwardfrom') },
        { value: 'header', text: this.$t('actions.header') }
      ]
    };
  },
  mounted() {
    const val = this.$route;
    console.log('new automaticRuleEditor', val);
    if (val.params.ruleid === '-1') {
      if (this.$store.state.newRule) {
        this.rule = this.$store.state.newRule;
        this.$store.commit('setNewRule', null);
        console.log('load new from store');
      } else {
        this.rule = {
          name: '',
          allconditions: false,
          id: -1,
          messagetypes: 'ILS',
          conditions: [],
          actions: [],
          order: this.$store.state.settings.msgrules.length + 1
        };
        console.log('load blank');
      }
    } else {
      this.rule = this.$store.state.settings.msgrules[parseInt(val.params.ruleid, 10)];
      console.log('load existing');
    }
    this.rule.actions.forEach(a => {
      a.folderdata = this.folders[0].value;
      a.addrdata = '';
      a.headerdata = '';
      a.keyworddata = '';
      if (['move', 'copy'].indexOf(a.action) !== -1) {
        a.folderData = a.data;
      } else if (['forward', 'forwardfrom'].indexOf(a.action) !== -1) {
        a.addrData = a.data;
      } else if (['header'].indexOf(a.action) !== -1) {
        a.headerData = a.data;
      } else if (['keywords'].indexOf(a.action) !== -1) {
        a.keywordData = a.data;
      }
    });
  },
  methods: {
    doAddCondition() {
      this.rule.conditions.push({ id: -1, field: 'from', match: '~ss', data: 'text' });
    },
    doDeleteCondition(ind) {
      this.$delete(this.rule.conditions, ind);
    },
    condMatch(ind) {
      let c = this.rule.conditions[ind].match;
      if (c.charAt(0) === '~') {
        c = c.substring(1);
      }
      switch (c) {
        case '!eq':
          return 'ne';
        case '!ne':
          return 'eq';
        case '!lt':
          return 'ge';
        case '!le':
          return 'gt';
        case '!gt':
          return 'le';
        case '!ge':
          return 'lt';
      }
      return c;
    },
    setInsensitive(ind, e) {
      let c = this.rule.conditions[ind].match;
      if (c.charAt(0) === '~') {
        c = c.substring(1);
      }
      if (e) {
        c = '~' + c;
      }
      this.rule.conditions[ind].match = c;
    },
    setMatch(ind, e) {
      let c = this.rule.conditions[ind].match;
      let m = /^([~]?)/.exec(c);
      console.log(m);
      this.rule.conditions[ind].match = m[0] + e;
    },
    doAddAction() {
      this.rule.actions.push({ action: 'markread',
        data: '',
        id: -1,
        folderData: this.folders[0].value,
        addrData: '',
        headerData: '',
        keywordData: '' });
    },
    doDeleteAction(ind) {
      this.$delete(this.rule.actions, ind);
    },
    updateActionData(ind) {
      let a = this.rule.actions[ind];
      switch (a.action) {
        case 'copy':
        case 'move':
          a.data = a.folderData;
          break;
        case 'header':
          a.data = a.headerData;
          break;
        case 'keywords':
          a.data = a.keywordData;
          break;
        case 'forward':
        case 'forwardfrom':
          a.data = a.addrData;
          break;
      }
    },
    getDefaultActionData(action, data) {
      return 'bob';
    },
    doSave() {
      let r = this.$store.state.settings.msgrules;
      if (this.$route.params.ruleid === '-1') {
        r.push(this.rule);
      } else {
        const ind = parseInt(this.$route.params.ruleid, 10);
        r[ind] = this.rule;
      }
      this.$store.dispatch('setSetting', { name: 'msgrules', value: r });
      if (this.$route.params.ruleid === '-1') {
        this.$router.replace({ name: 'rules' });
      } else {
        this.$router.push({ name: 'rules' });
      }
    }
  },
  computed: {
    folders() {
      return this.$store.getters.getFoldersAsOptions;
    },
    isValid() {
      if (!this.rule.name.trim() || !this.rule.conditions.length || !this.rule.actions.length) {
        return false;
      }
      if (this.rule.conditions.find(c => {
        if (c.data === '') {
          if ((c.match !== 'is') && (c.match !== 'notis')) {
            return true;
          }
        }
        return false;
      })) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style scoped>

</style>
